"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { NavigationIcon } from "../atoms/NavigationIcon";

const tabs = [
  {
    name: "Liquidity",
    id: "liquidity",
    svgBody: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.71 9.14V9.96001C14.71 10.77 15.63 11.23 16.27 10.74L20.88 7.25001C21.39 6.86001 21.39 6.09001 20.88 5.70001L16.27 2.20001C15.62 1.71001 14.71 2.17001 14.71 2.98001V3.81002C10.89 3.98006 7.48006 6.25004 5.58008 9.38001C6.71008 10.02 7.85008 10.62 9.01008 11.18C9.20008 10.98 9.40008 10.8 9.62008 10.63C11.11 9.43004 12.98 8.93004 14.71 9.14ZM23.5099 12.19C23.5099 13.52 23.2299 14.81 22.7399 16.02C21.5399 15.73 20.3499 15.41 19.1599 15.06C19.8299 14.16 20.3099 13.11 20.5299 11.96C20.6099 11.56 20.9799 11.28 21.3899 11.28H22.6199C23.1199 11.28 23.5099 11.69 23.5099 12.19ZM18.6101 15.71C18.3901 15.95 18.1501 16.17 17.9001 16.37C16.4101 17.57 14.5401 18.07 12.8101 17.86V23.19C16.7001 23.02 20.1701 20.67 22.0401 17.45C20.9101 16.84 19.7701 16.26 18.6101 15.71ZM12.8001 24.02V17.04C12.8001 16.23 11.8801 15.77 11.2401 16.26L6.63006 19.75C6.12006 20.14 6.12006 20.91 6.63006 21.3L11.2401 24.8C11.8901 25.29 12.8001 24.83 12.8001 24.02ZM4.78 10.96L4.77919 10.962L4.77 10.96H4.78ZM4.77919 10.962C4.2797 12.1714 4 13.4707 4 14.81C4 15.31 4.39 15.72 4.89 15.72H6.12C6.53 15.72 6.9 15.44 6.98 15.04C7.21 13.86 7.71 12.78 8.4 11.87C7.20301 11.5309 5.99608 11.2216 4.77919 10.962Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: "/liquidity",
    wildcards: ["/liquidity/"],
  },
  {
    name: "MNDE",
    id: "mnde",
    svgBody: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g id="mndeLogo">
          <path
            id="color"
            d="M21.789 7.3239C21.619 7.00183 20.9391 5.92829 19.6151 5.40941C18.9173 5.14102 18.0584 5.06945 17.137 5.22154C17.0744 5.23048 17.0028 5.24837 16.9133 5.26627C15.2672 5.63306 12.6639 7.86067 11.9034 8.5048C10.9283 9.3368 9.97106 10.0525 8.06552 11.4839C6.72358 12.4948 6.03472 12.969 5.93632 12.8706C5.83791 12.7632 6.36574 12.1101 6.89356 11.5018H6.69675C5.81107 11.3944 4.61228 11.4302 3.50294 12.0743C3.05563 12.3248 2.3131 12.7543 1.9463 13.6668C1.89262 13.8367 1.4811 14.8298 1.90157 15.6528C1.97314 15.787 2.16996 16.1449 2.58148 16.3685C3.55662 16.9142 4.74647 16.5743 5.30113 16.4043C5.75739 16.2612 6.16892 16.0822 6.16892 16.0822C6.82199 15.796 7.09038 15.5723 7.16195 15.6439C7.23352 15.7065 7.13511 16.0017 6.31206 17.12L6.44625 17.5852L6.93829 19.455C8.80805 18.614 10.7673 17.9431 12.7623 17.4689C15.2583 16.8695 17.8169 16.5743 20.3934 16.5743H20.4202L20.0535 14.6866C18.8547 14.3825 17.0565 14.0872 14.9183 14.3109C13.2275 14.4898 11.8408 14.9371 11.7961 14.794C11.7514 14.6598 12.9144 14.1409 14.0595 13.8099C15.0615 13.5236 15.9292 13.4252 16.5286 13.3805C16.5376 13.3447 16.5465 13.2731 16.5823 13.2105C16.8597 12.6469 17.0028 12.128 17.0744 11.6897C17.2175 10.8398 17.0654 10.303 17.1817 10.2762C17.298 10.2493 17.5396 10.7682 17.6738 11.2066C17.9153 11.9849 17.9064 12.7185 17.8258 13.3179C17.9779 13.3179 18.139 13.3179 18.3 13.3179C18.461 13.3179 18.6131 13.3179 18.7741 13.3358C19.0067 13.0495 19.293 12.6111 19.4898 12.0386C19.7224 11.3408 19.6777 10.7861 19.803 10.7771C19.9282 10.7682 20.0982 11.296 20.1608 11.7702C20.2592 12.4859 20.1161 13.0763 19.9908 13.4431C20.0445 13.4431 20.125 13.461 20.1698 13.461C20.2324 13.461 20.295 13.4789 20.3487 13.4789C20.3666 13.461 20.3845 13.4431 20.4024 13.4252C21.0286 12.8884 21.5206 12.2085 21.8338 11.4749C22.1916 10.6251 22.6658 8.94316 21.7801 7.33284L21.789 7.3239Z"
            fill="currentColor"
          />
        </g>
      </svg>
    ),
    href: "/mnde",
    wildcards: ["/mnde/"],
  },
];

interface MobileBottomNavProps {
  className?: string;
}

export const MobileBottomNav = ({ className }: MobileBottomNavProps) => {
  const pathname = usePathname();
  const isValidatorsDetailsPath = pathname?.includes("validators/details");

  return (
    <div
      className={`fixed bottom-0 pb-safe-bottom w-full bg-white flex justify-around items-center z-50 ${className} ${
        isValidatorsDetailsPath ? "hidden" : ""
      }`}
    >
      {tabs.map((tab) => {
        const tabActive = tab.wildcards?.some((path) =>
          pathname?.includes(path)
        );
        const tabTextColor = tabActive ? "text-primary" : "text-tertiary-text";
        const tabIconColor = tabActive ? "text-primary" : "text-tertiary-text";

        if (tab.id === "more") {
          return (
            <div
              key={`m_motion_${tab.id}`}
              className="hs-dropdown relative inline-flex [--trigger:hover]"
            >
              <motion.button
                id="hs-dropdown-hover-event"
                type="button"
                whileTap={{ scale: 0.95, animationDuration: "0.2s" }}
                className={`hs-dropdown-toggle [--strategy:static] md:[--strategy:absolute] [--adaptive:none] md:[--trigger:hover] flex flex-col items-center font-semibold py-3 mr-1 ${tabTextColor}`}
              >
                <NavigationIcon
                  svgBody={tab.svgBody}
                  className={tabIconColor}
                />
                <div className="text-sm pt-1">{tab.name}</div>
              </motion.button>
            </div>
          );
        }

        return (
          <motion.div
            key={`m_motion_${tab.id}`}
            whileTap={{ scale: 0.95, animationDuration: "0.2s" }}
          >
            <Link
              key={`m_nav_${tab.id}`}
              href={tab.href}
              className={`flex flex-col items-center font-semibold py-3 ${tabTextColor}`}
            >
              <NavigationIcon svgBody={tab.svgBody} className={tabIconColor} />
              <div className="text-sm pt-1">{tab.name}</div>
            </Link>
          </motion.div>
        );
      })}
    </div>
  );
};
